import { render, staticRenderFns } from "./neighborViewlist.vue?vue&type=template&id=7b2e01ed&"
import script from "./neighborViewlist.vue?vue&type=script&lang=js&"
export * from "./neighborViewlist.vue?vue&type=script&lang=js&"
import style0 from "./neighborViewlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports